import styled from 'styled-components';
import { ArrowProps } from './types';

export const CarouselContainer = styled.div`
  overflow: hidden;
`;

export const InnerContainer = styled.div`
  white-space: nowrap;
  transition: transform 0.3s;
  display: flex;
  align-items: stretch;
  gap: 0px;
  width: 300%;
`;

export const CarouselItem = styled.div`
  display: inline-flex;
  align-items: stretch;
  justify-content: center;
  color: #ffffff;
  min-height: fit-content;
  width: 100%;
`;

export const Indicators = styled.div`
  display: flex;
  justify-content: center;
  & > div {
    margin-right: 8px;
  }
  & > div:last-child {
    margin-right: 0;
  }
`;

export const IndicatorDot = styled.div<{ is_active: string }>`
  width: ${({ is_active }) => (is_active === 'true' ? '16px' : '8px')};
  height: 8px;
  background: ${({ is_active }) =>
    is_active === 'true' ? '#51459E' : '#C9CBD2'};

  border-radius: ${({ is_active }) => (is_active === 'true' ? '8px' : '50%')};
  display: block;
`;

const Arrow = styled.button`
  border-radius: 50%;
  height: 56px;
  width: 56px;
  background: transparent;
  position: absolute;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  padding: 0;
  border: 0;
  @media (max-width: 834px) {
    height: 36px;
    width: 36px;
  }
`;

export const ArrowLeft = styled(Arrow)<ArrowProps>`
  position: ${({ desktop }) => (desktop?.x ? 'absolute' : 'relative')};
  left: ${({ desktop }) => desktop?.x};
  top: ${({ desktop }) => desktop?.y};

  @media (max-width: 1000px) {
    display: ${({ desktop }) => (desktop?.x ? 'none' : 'block')};
  }

  @media (min-width: 1001px) {
    display: ${({ desktop }) => (desktop?.x ? 'block' : 'none')};
  }
`;

export const ArrowRight = styled(Arrow)<ArrowProps>`
  position: ${({ desktop }) => (desktop?.x ? 'absolute' : 'relative')};
  right: ${({ desktop }) => desktop?.x};
  top: ${({ desktop }) => desktop?.y};

  @media (max-width: 1000px) {
    display: ${({ desktop }) => (desktop?.x ? 'none' : 'block')};
  }

  @media (min-width: 1001px) {
    display: ${({ desktop }) => (desktop?.x ? 'block' : 'none')};
  }
`;
export const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;
